import PropTypes from "prop-types";

const Balloon = (props) => {
  const { color } = props;
  return (
    <svg data-testid="Balloon" viewBox="0 0 36 80" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <path
          d="M17.834955,0 C17.7897896,0 17.7461817,0 17.701795,0.000778409243 L17.701795,0.000778409243 C17.6566295,0 17.6122429,0 17.5678562,0 L17.5678562,0 L17.4892061,0 C7.6649511,0.0171250033 0.5436122,7.40889917 0.019537724,18.8966628 L0.019537724,18.8966628 C-0.460928771,29.4339887 7.98967481,42.0247582 17.701795,44.4269291 L17.701795,44.4269291 C13.9865508,48.0371912 15.2651991,48.5369299 17.701795,48.5369299 L17.701795,48.5369299 C19.893096,48.5369299 21.4785575,48.0971287 17.701795,44.4269291 L17.701795,44.4269291 C27.1071018,42.1002639 35.3279848,30.2194036 35.4027413,19.9015891 L35.4027413,19.9015891 L35.4027413,19.619805 C35.4011839,19.3784981 35.3949542,19.1364128 35.3840522,18.8966628 L35.3840522,18.8966628 C34.8599777,7.40967758 27.7378601,0.0179034126 17.9136051,0 L17.9136051,0 L17.834955,0 Z"
          id="path-1"
        />
        <path
          d="M7.71015381,0.157238667 C3.08615048,2.26127885 0.27655062,6.92083658 0.0016646022,12.9402753 L0.0016646022,12.9402753 C-0.0396072361,13.8572413 0.691605145,14.6340938 1.63618514,14.674571 L1.63618514,14.674571 C1.6618827,14.6753495 1.68680155,14.6753495 1.71249911,14.6753495 L1.71249911,14.6753495 C2.62281569,14.6753495 3.37972564,13.9794516 3.42021876,13.0873946 L3.42021876,13.0873946 C3.63670123,8.34532549 5.72910556,4.72961456 9.16167657,3.16812562 L9.16167657,3.16812562 C10.0174832,2.778921 10.3858149,1.78956285 9.9847772,0.958221778 L9.9847772,0.958221778 C9.6943169,0.354176206 9.07757547,0 8.43435776,0 L8.43435776,0 C8.19139901,0 7.9445467,0.0505966008 7.71015381,0.157238667 L7.71015381,0.157238667 Z"
          id="path-3"
        />
      </defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Balloon-groups" transform="translate(-315.000000, -165.000000)">
          <g id="Modal" transform="translate(24.000000, 57.000000)">
            <g id="Group" transform="translate(15.000000, 36.000000)">
              <g id="Balloons" transform="translate(40.000000, 0.000000)">
                <g id="Blue-Balloon" transform="translate(236.597259, 72.761386)">
                  <path
                    d="M17.7545139,48.1274088 C20.7136268,52.2654324 20.6357554,56.6696719 17.5208997,61.3401273 C14.406044,66.0105828 14.4839154,71.6431521 17.7545139,78.2386136"
                    id="Stroke-1"
                    stroke="#BABABA"
                    strokeWidth="1.17"
                    strokeLinecap="square"
                  />
                  <g id="Group-5">
                    <mask id="mask-2" fill="white">
                      <use xlinkHref="#path-1" />
                    </mask>
                    <g id="Clip-4" />
                    <polygon
                      id="Fill-3"
                      fill={color}
                      mask="url(#mask-2)"
                      points="-3.89349978 52.4289761 39.296311 52.4289761 39.296311 -3.89282462 -3.89349978 -3.89282462"
                    />
                  </g>
                  <g id="Group-8" transform="translate(3.998659, 4.233768)">
                    <mask id="mask-4" fill="white">
                      <use xlinkHref="#path-3" />
                    </mask>
                    <g id="Clip-7" />
                    <polygon
                      id="Fill-6"
                      fill="#FEFEFE"
                      mask="url(#mask-4)"
                      points="-3.89346248 18.5681741 14.0410981 18.5681741 14.0410981 -3.89204621 -3.89346248 -3.89204621"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

Balloon.propTypes = {
  color: PropTypes.string.isRequired,
};

export default Balloon;
